import React, {useState, useEffect} from 'react'
import './transHist.style.css'
import './transHisDe.style.css'
import Overlay from '../../components/Overlay';
import { NhealthAction } from '../../_actions/action.api'
import { Base_API } from '../../_actions/matcher'
import axios from 'axios';
//! Line Liff
import liff from '@line/liff'
// Mockup Data
import History from '../../utils/JSON/history.json'
import HistoryDetails from '../../utils/JSON/hisdetails.json'
// Components
import TransHisCard from '../../components/TransHisCard';
import TransHisDetails from '../../components/TransHisDetails';
import { DecryptedOBJ, EncryptedOBJ } from '../../utils/Encryption';
import lineConfig from '../../_actions/authLine/lineConfig';
import useLineLogin from '../../_actions/authLine/lineLogin';


function AppointHistory() {

    const [openDetail, setOpenDetail] = useState(false);
    const [hisData, setHisData] = useState([]);
    const [hisDetailsData, setHisDetailsData] = useState(null);
    const [lineProfileData, setLineProfileData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Get Transaction History
        dataInit();
    },[])

    const dataInit = async() => {
        await useLineLogin(lineConfig.appoint_history);
        await transHisInit();
        handlerLoader('inactive');
    }

    const handlerLoader = status => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const transHisInit = () => {
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(lineProfile !== null)
            {
                // console.log(lineProfile);
                NhealthAction.GetTransHistory(lineProfile.user_id)
                .then(res => {
                    if(res.isSuccess === true)
                    {
                        setHisData(res.historylist);
                    }
                    resolve();
                    // console.log("Get Transaction History: ", res.historylist[0].refNo);
                })
            }else
            {
                await useLineLogin(lineConfig.appoint_history);
            }
        }) 
    }

    const userInitLine = () => {
        liff.init({ liffId: lineConfig.appoint_history }, () => {
            if (liff.isLoggedIn()) {
              runApp();
            } else {
              liff.login();
            }
        }, err => console.error(err));
    }

    const runApp = () => {
        const idToken = liff.getIDToken();
        const accessToken = liff.getAccessToken();
        let lineProfile;

        liff.getProfile().then(profile => {
            lineProfile = {
                id_token: idToken,
                display_name: profile.displayName,
                picture_url: profile.pictureUrl,
                status_message: profile.statusMessage,
                user_id: profile.userId,
                access_token: accessToken
            }
            window.localStorage.setItem('line_profile', EncryptedOBJ(lineProfile)); //encrypted!
            setLineProfileData(lineProfile);
        })
        .then(() => {
            // console.log(lineProfile)
            hisDataLineInit(lineProfile.user_id, lineProfile.id_token); 
        })
    }

    // open details window
    const onSelect = async(transID) => {
        await hisByTranIDInit(transID);
        setOpenDetail(true);
        document.body.style.overflow = 'hidden'
    }

    const hisByTranIDInit = (transID) => {
        return new Promise(async resolve => {
            NhealthAction.GetTransHisByTransID(transID)
            .then(res => {
                if(res.isSuccess === true)
                {
                    setHisDetailsData(res.history)
                    resolve();
                }
                // console.log(res);
            })
        })
    }

    const hisDataLineInit = (userid, token) => {
        let reqData = {
            line_user: userid,
        }        
        // For Dev
        // setHisData(TransHisData.historylist);
        // setLoading(false);
        // console.log(TransHisData.historylist)
        
        // For Publish
        // NhealthAction.GetHistory(reqData)
        // .then(res => {
        //     // console.log('Line :', res)
        //     if(res.isSuccess === true)
        //     {
        //         //! Mockup Data ไว้ก่อน
        //         // setHisData(res.historylist); 
        //         setLoading(false);
        //     }else
        //     {
        //         setHisData([]); 
        //         setLoading(false)
        //     }
        //     if(res.isSuccess === false)
        //     {
        //         setHisData([]); 
        //         setLoading(false)
        //     }
        // })
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="transhis-con">
                {/* Content Wrap */}
                <div className="transhis-wrap">
                    {/* Title */}
                    <h1 className="header">ประวัติการทำรายการ</h1>
                    {/* Transactions List */}
    
                    {/* - For Prod */}
                    {hisData.length < 1 &&
                        <div className="his-notfound">ไม่พบข้อมูล</div>
                    }

                    {hisData.length > 0 &&
                        hisData.map(item => 
                            <TransHisCard key={item.id} onSelect={onSelect} data={item} />
                        )                    
                    }
                    {/* - For Dev */}
                    {/* <TransHisCard onSelect={onSelect} data={History} /> */}
                    <TransHisDetails setOpenDetail={setOpenDetail} openDetail={openDetail} detailData={hisDetailsData} />
    
                </div>
                {/* overlay */}
                <Overlay 
                    openDetail={openDetail} 
                    setOpenDetail={setOpenDetail}
                />
            </div>
        )
    }
}

export default AppointHistory;